import { TmFilterForm } from './tm-filter-form.component';

type TmFilterFormApplyPayload<T> = T | undefined;

export type TmFilterFormApplyEvent<T> = CustomEvent<TmFilterFormApplyPayload<T>>;

export enum TmFilterFormEvent {
    Apply = 'filter-form-apply',
    ValidityChange = 'change-validity',
}

type TmFilterFormPayloadMap<T = unknown> = {
    [TmFilterFormEvent.Apply]: TmFilterFormApplyPayload<T>;
    [TmFilterFormEvent.ValidityChange]: void;
};

export function dispatchFilterFormEvent<T, Event extends TmFilterFormEvent>(
    target: TmFilterForm<T>,
    eventType: Event,
    detail: TmFilterFormPayloadMap<T>[Event]
) {
    const event = new CustomEvent<typeof detail>(eventType, {
        detail,
        bubbles: true,
        composed: true,
    });
    target.dispatchEvent(event);
}

export function listenForFilterFormEvent<T, Event extends TmFilterFormEvent>(
    target: TmFilterForm<T>,
    eventType: Event,
    fn: (event: CustomEvent<TmFilterFormPayloadMap<T>[Event]>) => void
) {
    target.addEventListener(eventType, fn as EventListener);
    return {
        unsubscribe: () => target.removeEventListener(eventType, fn as EventListener),
    };
}
